import { useQuery } from "@tanstack/react-query";
import React from "react";
import { useLocation } from "react-router-dom";
import { HelmetDexteel } from "../../../helmet/HelmetDexteel";
import type { EmailAddress } from "../emailTopics/models/EmailAddress";
import { getEmailAddresses } from "../emailTopics/repositories/EmailTopicsRepository";
import { TableEmailAddresses } from "./components/TableEmailAddresses";

export const getEmailAddressRouteState = (
	pathname: string,
): { modal: "" | "create" | "update"; emailAddressId?: string } => {
	if (!pathname.startsWith("/configuration/email-addresses")) {
		return { modal: "" };
	}

	const [routeValue, action] = pathname
		.slice("/configuration/email-addresses".length)
		.split("/")
		.filter(Boolean);

	if (!routeValue) {
		return { modal: "" };
	}

	if (routeValue === "new") {
		return { modal: "create" };
	}

	if (action) {
		return { modal: "" };
	}

	return { modal: "update", emailAddressId: routeValue };
};

export const useEmailAddresses = ({
	includeSystem = false,
	enabled = true,
}: { includeSystem?: boolean; enabled?: boolean } = {}) => {
	return useQuery<EmailAddress[], Error>({
		queryKey: ["emailAddresses", includeSystem],
		queryFn: ({ signal }) => getEmailAddresses({ includeSystem }, signal),
		enabled,
	});
};

export const EmailAddressesPage = () => {
	const location = useLocation();
	const routeState = getEmailAddressRouteState(location.pathname);

	return (
		<>
			<HelmetDexteel title="Email Addresses" />
			<TableEmailAddresses
				emailAddressId={routeState.emailAddressId}
				routeModal={routeState.modal}
			/>
		</>
	);
};
